import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { Field, FieldCreateDTO } from '../types/fields';

@Injectable({
  providedIn: 'root'
})
export class FieldsService {
  private apiUrl = `${environment.apiUrl}/fields`;

  private fieldsSubject = new BehaviorSubject<Field[] | null>(null);
  private fieldsCache$: Observable<Field[]> | null = null;

  constructor(private http: HttpClient) { }

  getFields(): Observable<Field[]> {
    if (!this.fieldsCache$) {
      this.fieldsCache$ = this.http.get<Field[]>(this.apiUrl).pipe(
        tap(fields => this.fieldsSubject.next(fields)),
        shareReplay(1)
      );
    }
    return this.fieldsCache$;
  }

  getFieldById(id: string): Observable<Field> {
    return this.http.get<Field>(`${this.apiUrl}/${id}`);
  }

  createField(field: FieldCreateDTO): Observable<Field> {
    return this.http.post<Field>(this.apiUrl, field).pipe(
      tap(() => this.clearCache())
    );
  }

  updateField(id: string, field: Partial<FieldCreateDTO>): Observable<Field> {
    return this.http.put<Field>(`${this.apiUrl}/${id}`, field).pipe(
      tap(() => this.clearCache())
    );
  }

  deleteField(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => this.clearCache())
    );
  }

  refreshFieldsCache(): Observable<Field[]> {
    this.clearCache();
    return this.getFields();
  }

  private clearCache(): void {
    this.fieldsCache$ = null;
    this.fieldsSubject.next(null);
  }
}
